import { Mask } from '@hapvida/hapvida-core-components';

import type { CoparticipationSubRowProps } from './types';
import {
  StyledEmptyTableCell,
  StyledSubTableCell,
  StyledSubTableRow,
  StyledSubTableTypography,
} from './styles';

export function CoparticipationSubRow({
  detail,
  index,
  detailsLength,
  columnsSubRow,
}: CoparticipationSubRowProps) {
  return (
    <StyledSubTableRow
      key={detail.id}
      index={index}
      detailsLength={detailsLength}
    >
      {columnsSubRow.map((column, colIndex) => {
        const isLastColumn = colIndex === columnsSubRow.length - 1;
        const keyColumn = column.id as keyof typeof detail;
        const value = detail[keyColumn] ?? '-';

        return (
          <StyledSubTableCell key={column.id} align={column.align}>
            <StyledSubTableTypography
              variant="text"
              fontWeight={isLastColumn ? 700 : 400}
            >
              {isLastColumn ? Mask.currency(Number(value)) : value}
            </StyledSubTableTypography>
          </StyledSubTableCell>
        );
      })}
      <StyledEmptyTableCell />
    </StyledSubTableRow>
  );
}
